import { callable } from './callable'

export interface ClientOutreachConfig {
  disabled: boolean
  dailyCapDefault: number
}

export interface UpdateClientOutreachConfigInput {
  disabled?: boolean
  dailyCapDefault?: number
  confirm?: string
}

export interface ListClientOutreachWorkspacesInput {
  cursor?: string | null
  search?: string | null
}

export interface ClientOutreachWorkspaceItem {
  id: string
  name: string
  timezone: string
  clientOutreachEnabled: boolean
  disabled: boolean
  overrideDailyCap: number | null
  effectiveDailyCap: number
  todayCount: number | null
  todayError?: boolean
}

export interface UpdateClientOutreachWorkspaceInput {
  workspaceId: string
  dailyCap?: number | null
  disabled?: boolean
}

export interface ListClientOutreachStatsInput {
  days?: number
  cursor?: string | null
}

export interface ClientOutreachDailyStatEntry {
  dayKey: string
  sent: number
  bounced: number
  complained: number
  optedOut: number
}

export type ClientOutreachDailyStatItem = ClientOutreachDailyStatEntry

export interface ClientOutreachWorkspaceStatsItem {
  workspaceId: string
  name: string
  totals: {
    sent: number
    bounced: number
    complained: number
    optedOut: number
  }
  days: ClientOutreachDailyStatEntry[]
  error?: boolean
}

export interface ClientOutreachSummary {
  totals: {
    sent: number
    bounced: number
    complained: number
    optedOut: number
  }
  days: ClientOutreachDailyStatEntry[]
}

export interface ListClientOutreachStatsResponse {
  items: ClientOutreachWorkspaceStatsItem[]
  nextCursor: string | null
  truncated: boolean
  days: number
  partial?: boolean
  summary: ClientOutreachSummary
}

export async function getClientOutreachConfig(): Promise<ClientOutreachConfig> {
  return await callable('getClientOutreachConfig', {})
}

export async function updateClientOutreachConfig(
  input: UpdateClientOutreachConfigInput,
): Promise<ClientOutreachConfig> {
  return await callable('updateClientOutreachConfig', input)
}

export interface ListClientOutreachWorkspacesResponse {
  items: ClientOutreachWorkspaceItem[]
  nextCursor: string | null
  partial?: boolean
}

export async function listClientOutreachWorkspaces(
  input: ListClientOutreachWorkspacesInput = {},
): Promise<ListClientOutreachWorkspacesResponse> {
  return await callable('listClientOutreachWorkspaces', input)
}

export async function updateClientOutreachWorkspace(
  input: UpdateClientOutreachWorkspaceInput,
): Promise<{ workspaceId: string; dailyCap: number | null; disabled: boolean }> {
  return await callable('updateClientOutreachWorkspace', input)
}

export async function listClientOutreachStats(
  input: ListClientOutreachStatsInput = {},
): Promise<ListClientOutreachStatsResponse> {
  return await callable('listClientOutreachStats', input)
}
